import React, { useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import * as PIXI from "pixi.js";
// @ts-ignore
import { Live2DModel } from 'pixi-live2d-display-lipsyncpatch/cubism4';

const MODEL_PATH_LIST = [
    "/assets/Haru/Haru.model3.json",
    "/assets/Hiyori/Hiyori.model3.json",
    "/assets/Mao/Mao.model3.json",
    "/assets/Mark/Mark.model3.json",
    "/assets/Natori/Natori.model3.json",
    "/assets/Rice/Rice.model3.json",
];

declare global {
    interface Window {
        PIXI: typeof PIXI;
    }
}
window.PIXI = PIXI;

export interface Live2DInstance {
    playMotion: (audioUrl: string, options?: {
        volume?: number;
        expression?: number;
        resetExpression?: boolean;
        crossOrigin?: string;
        onFinish?: () => void;
        onError?: (error: any) => void;
    }) => void;
    stopMotions: () => void;
}

interface Live2DProps {
    width?: number;
    height?: number;
}

const Live2DComponent = forwardRef<Live2DInstance, Live2DProps>(({ width = 400, height = 800 }, ref) => {
    const appRef = useRef<PIXI.Application | null>(null);
    const modelRef = useRef<any>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({
        playMotion: (audioUrl, options) => {
            if (!modelRef.current) return;
            const {
                volume = 1,
                expression = 4,
                resetExpression = false,
                crossOrigin = "anonymous",
                onFinish,
                onError
            } = options || {};
            try {
                // modelRef.current.motion('Idle', 0, 3, {
                //     sound: audioUrl,
                //     volume,
                //     expression,
                //     resetExpression,
                //     crossOrigin,
                //     onFinish,
                //     onError
                // });
                modelRef.current.speak(audioUrl, {
                    volume: volume,
                    expression: expression,
                    resetExpression: resetExpression,
                    crossOrigin: crossOrigin,
                    onFinish,
                    onError
                  });
            } catch (e) {
                onError?.(e);
            }
        },
        stopMotions: () => {
            modelRef.current?.stopSpeaking();
        },
    }), []);

    useEffect(() => {
        const init = async () => {
            const app = new PIXI.Application({ width, height, backgroundAlpha: 0 });
            appRef.current = app;
            if (containerRef.current) {
                containerRef.current.appendChild(app.view as HTMLCanvasElement);
                const model = await Live2DModel.from(MODEL_PATH_LIST[0]);
                if (!app.renderer) return;
                modelRef.current = model;
                app.stage.addChild(model);
                model.x = app.renderer.width / 2;
                model.y = app.renderer.height + 10;
                model.anchor.set(0.5, 1);
                model.scale.set(calculateScale(model));
            }
        };
        init();
        return () => {
            appRef.current?.destroy(true, true);
            if (containerRef.current) containerRef.current.innerHTML = "";
        };
    }, [width, height]);

    const calculateScale = (model: any) => {
        const modelWidth = model.internalModel?.canvasInfo?.width || model.internalModel.originalWidth || 2048;
        const modelHeight = model.internalModel?.canvasInfo?.height || model.internalModel.originalHeight || 2048;
        const scaleX = width / modelWidth;
        const scaleY = height / modelHeight;
        return Math.min(scaleX, scaleY);
    };

    return <div ref={containerRef} style={{ width, height, position: 'relative' }} />;
});

Live2DComponent.displayName = 'Live2DComponent';
export default Live2DComponent;
